export default "__VITE_ASSET__CQsn60AT__"